export const MODULE_NAME = 'integrations/connectif'

// Connectif Page Tags
export const CONNECTIF_PAGE_TAGS = {
  HOME: 'Pagina_Home',
  LANDING_SEO: 'Pagina_LandingSEO',
  DETAIL: 'Pagina_Ficha',
  OWNER: 'Pagina_AP-propietario',
  TRAVELER: 'Pagina_AP-viajero',
  OTHERS: 'Pagina_Otros',
  LIST: 'Pagina_Listado',
} as const

// Connectif Content Tags
export const CONNECTIF_CONTENT_TAGS = {
  HOME: 'Contenido_Home',
  TRANSACTIONAL: 'Contenido_Transaccional',
  OTHERS: 'Contenido_Otros',
  OWNER: 'Contenido_Propietario',
} as const

// Connectif Content Tags
export const CONNECTIF_DEFAULT_PRICE = {
  CONTACT: 1000,
  PHONE: 100,
} as const

export const CONNECTIF_CUSTOM_EVENTS = {
  SHARE: 'share',
  PRICES_PAGE_VIEW: 'prices-page-view',
  SAVE_FAVOURITES: 'save-favourites',
  SEND_REVIEW: 'send-review',
}
